import React from 'react';
import { FileUploadProps } from './types';
import { onelineLayout } from './file-upload-view-oneline.styles';
import { PictureCover } from './content-blocks/picture-cover';
import { DropzoneCaptionInside } from './content-blocks/dropzone-caption-inside';
import { DropzoneNoCaption } from './content-blocks/dropzone-no-caption';

export const FileUploadViewOneline: React.FC<FileUploadProps> = ({
  className,
  picCovers = [],
  inputProps,
  onRetryClick,
  onRemoveClick,
  onFileSelectionClick,
  onFilesSelect,
  ...htmlProps
}) => {
  const DropzoneView = picCovers.length > 0 ? DropzoneNoCaption : DropzoneCaptionInside;
  const onRetryCb = React.useCallback(
    (src: string) => {
      onRetryClick?.(src);
    },
    [onRetryClick],
  );

  const onRemoveCb = React.useCallback(
    (src: string) => {
      onRemoveClick?.(src);
    },
    [onRemoveClick],
  );

  const picCoversMemoized = React.useMemo(
    () =>
      picCovers.map(({ src, isInProcessing, processingIsFailed }) => (
        <PictureCover
          key={src}
          src={src}
          onRetryClick={onRetryCb}
          onRemoveClick={onRemoveCb}
          isInProcessing={isInProcessing}
          processingIsFailed={processingIsFailed}
          data-qa="pic-cover_mf-pdp"
        />
      )),
    [picCovers, onRetryCb, onRemoveCb],
  );

  const onFileSelectionClickCb = React.useCallback(() => onFileSelectionClick?.(), [onFileSelectionClick]);

  return (
    <div className={className} {...htmlProps}>
      <div className={onelineLayout}>
        <>{picCoversMemoized}</>

        <DropzoneView
          onClick={onFileSelectionClickCb}
          onFilesSelect={onFilesSelect}
          inputProps={inputProps}
          data-qa="dropzone-view_mf-pdp"
        />
      </div>
    </div>
  );
};
